import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import { getQiNiuLazyImg } from '@ykz/ykz-util/platform';
export default {
  name: 'edit-item',
  props: {
    item: {
      default: null
    },
    inPreview: {
      default: true
    },
    index: {
      default: 0
    },
    length: {
      default: 0
    }
  },
  data: function data() {
    return {};
  },
  filters: {
    _showTopText: function _showTopText(value) {
      switch (~~value) {
        case 1:
          return '取消置顶';
        default:
          return '置顶';
      }
    },
    _showAddress: function _showAddress(value) {
      value = value.replace(/(市*$)|(街道*$)|(县*$)/g, "");
      if (value.length > 4) {
        value = value.substring(0, 4);
      }
      return value;
    },
    _showBusiness: function _showBusiness(value) {
      if (value && value.length > 8) {
        value = value.substring(0, 8);
      }
      return value ? '-' + value : '';
    },
    _showMarketPrice: function _showMarketPrice(value) {
      if (String(value).length > 5) {
        return parseInt(value);
      }
      return Number(value || '');
    }
  },
  methods: {
    showCountDown: function showCountDown(item) {
      return Number(item.earnInt || '') < 1000 && Number(item.priceInt || '') < 10000;
    },
    //图片懒加载
    getLazyImg: function getLazyImg(img, stage) {
      return getQiNiuLazyImg(img, stage);
    },
    // 删除
    remove: function remove() {
      this.$emit('remove', {
        index: this.index,
        item: this.item
      });
    },
    // 删除
    toTop: function toTop() {
      this.$emit('totop', {
        index: this.index,
        item: this.item
      });
    }
  }
};